
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'accordion',

  setup(props) {
    const handleClick = (e) => {
      const accordionItems = document.querySelectorAll('.accordion-item');
      accordionItems.forEach(item => {
        if (item) {
          if (item !== e.target.parentElement) {
            if (item.classList.contains('active')) {
              item.classList.remove('active')
            }
          }
        }
      })
      e.target.parentElement.classList.toggle('active')
    }

    return {
      handleClick,
    };
  },
});
